import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BackendurlService } from './backendurl.service';
import { BackEndURLSettings } from './backEndUrlSettings';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentLoaderService {
  private settings: BackEndURLSettings;
  public static envConfig: BackEndURLSettings;
  // public static _generalLicense:generalLicense;
  // public static _stockLicense:stockLicense;
  // public static _assetLicense:assetLicense;
  // public static _licenseLoaded:boolean = false;
  static EnvironmentLoaderService: {};
  constructor(private injector: Injector) { }
  http: HttpClient
  // static sett:BackEndURLSettings;
  async loadEnvConfig(configPath: string): Promise<BackEndURLSettings> {
    this.http = this.injector.get(HttpClient);
    this.settings = await lastValueFrom(this.http.get<BackEndURLSettings>(configPath));
    BackendurlService.settings = this.settings;
    EnvironmentLoaderService.envConfig = this.settings;
    localStorage.setItem("localKey", JSON.stringify(this.settings));
    // EnvironmentLoaderService._assetLicense = <assetLicense>({});
    // EnvironmentLoaderService._generalLicense = <generalLicense>({});
    // EnvironmentLoaderService._stockLicense = <stockLicense>({});

    // EnvironmentLoaderService.sett = this.settings;
    return this.settings;
    /*  environment.api.urls['enterpriseApi'] = this.settings.enterpriseApiLocal;
     environment.barcloudUrl = this.settings.barcloudUrlLocal;
     environment.url = this.settings.urlLocal;
 
     envProd.api.urls['enterpriseApi'] = this.settings.enterpriseApi;
     envProd.barcloudUrl = this.settings.barcloudUrl;
     envProd.url = this.settings.url; */

  }

  public get getEnvConfig(): BackEndURLSettings {
    return this.settings;
  }
}
